import React from 'react';

import { SettingsCoordinator } from '~settings-coordinator/SettingsCoordinator';
import { SettingsFormikContainer } from '~src/settings/components/common/SettingsFormikContainer';
import { MobileSiteSettingsSubspaceState } from '~src/settings/components/subspaces/SiteSettingsSpace/MobileSiteSettingsSpace';
import { coordinatorSubmitFailedHandler,coordinatorSubmitHandler } from '~src/settings/general-settings/components/common/GeneralToastHandlers';
import { ISiteAdminSettings, ISiteSubscriptionSettings } from '~src/settings/types/ISiteSettingsForSiteAdmin';
import { Sites } from '~src/siteManagement/services/resources/Sites';

import { MobileSecuritySettingsService } from '../MobileSecuritySettingsShared';
import { MobileSecuritySettingsTelemetrySettingLocation, sendUpdateMobileSecuritySettingsTelemetry } from '../MobileSecuritySettingsTelemetry';

export type MobileSiteSettingsSubFormikProps = {
  settings: MobileSiteSettingsSubspaceState;
}

/**
 * Creates a mobile settings coordinator with the site settings
 */
export function MobileSiteSettingsCoordinator(props: MobileSiteSettingsSubspaceState) {
  let sections = Array<string>();
  sections.push('MobileGeneralSettingsSection');
  sections.push('MobileSecuritySettingsSection');

  return (
    <SettingsCoordinator
      onSubmit={coordinatorSubmitHandler}
      onSubmitFailure={coordinatorSubmitFailedHandler}
      submitSequentially = {true}>

      <SettingsFormikContainer
        formName={'ReactMobileSiteSettings'}
        settings={props}
        siteId={props.siteSettingsForSiteAdmin.siteId}
        sections={sections}
        onSubmit={useSubmitHandler(props)}
      >
      </SettingsFormikContainer>

    </SettingsCoordinator>
  );
}

function useSubmitHandler(settings: MobileSiteSettingsSubspaceState) {
  return React.useCallback(
    async (settings: MobileSiteSettingsSubspaceState) => {
      const siteId = (settings.siteSettingsForSiteAdmin as any).id || settings.siteSettingsForSiteAdmin.siteId;
      const newSiteAdminSettings = settings.siteSettingsForSiteAdmin.siteAdminSettings as ISiteAdminSettings;
      const subscriptionSettings = settings.siteSettingsForSiteAdmin.subscriptionSettings as ISiteSubscriptionSettings;

      sendUpdateMobileSecuritySettingsTelemetry(settings.mobileSecuritySettings, MobileSecuritySettingsTelemetrySettingLocation.site_settings);

      await Promise.all([
        Sites.instance.updateSiteSettingsForSiteAdmin(siteId, newSiteAdminSettings, subscriptionSettings),
        MobileSecuritySettingsService.setMobileSecuritySettingsForSite(siteId, settings.mobileSecuritySettings)
      ]);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [settings]
  );
}
